export const LMS = {
  loginTab: 'lms-login-tab',
  registerTab: 'lms-register-tab',
  loginEmail: 'lms-login-email-input',
  loginPassword: 'lms-login-password-input',
  loginSubmit: 'lms-login-submit-button',
  registerName: 'lms-register-name-input',
  registerEmail: 'lms-register-email-input',
  registerPhone: 'lms-register-phone-input',
  registerCountryCode: 'lms-register-country-code',
  registerPassword: 'lms-register-password-input',
  registerConfirmPassword: 'lms-register-confirm-password-input',
  registerSubmit: 'lms-register-submit-button',
  demoStudentBtn: 'lms-demo-student-button',
  demoAdminBtn: 'lms-demo-admin-button',
};

export const ADMIN = {
  sidebar: 'admin-sidebar',
  navBatches: 'admin-nav-batches',
  navVideos: 'admin-nav-videos',
  navResources: 'admin-nav-resources',
  navEbooks: 'admin-nav-ebooks',
  navStudents: 'admin-nav-students',
  navPayments: 'admin-nav-payments',
  createBatchButton: 'admin-create-batch-button',
  uploadVideoButton: 'admin-upload-video-button',
  uploadResourceButton: 'admin-upload-resource-button',
  logoutButton: 'admin-logout-button',
};

export const STUDENT = {
  sidebar: 'student-sidebar',
  sidebarBatchName: 'student-sidebar-batch-name',
  sidebarProgressValue: 'student-sidebar-progress-value',
  navOverview: 'student-nav-overview',
  navEnrollments: 'student-nav-enrollments',
  navRecordings: 'student-nav-recordings',
  navResources: 'student-nav-resources',
  navEbooks: 'student-nav-ebooks',
  navCertificates: 'student-nav-certificates',
  navProfile: 'student-nav-profile',
  videoCard: 'student-video-card',
  resourceDownload: 'student-resource-download',
  logoutButton: 'student-logout-button',
  statSessionsWatched: 'student-stat-sessions-watched',
  statResourcesDownloaded: 'student-stat-resources-downloaded',
  statHoursLearned: 'student-stat-hours-learned',
  statCertificateStatus: 'student-stat-certificate-status',
  continueWatchingResume: 'student-continue-watching-resume',
  continueWatchingPlay: 'student-continue-watching-play',
  continueWatchingTitle: 'student-continue-watching-title',
  latestResourcesList: 'student-latest-resources-list',
};
